import { useState, Fragment, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorMessage } from 'ui/shared/messages';
import { IconTextField } from 'ui/shared/controls';
import { TermsOfServiceDialog } from '../termsOfServiceDialog/TermsOfServiceDialog';

require('./UsernamePanel.css');

export type Props = {
    active: boolean;
    busy: boolean;
    errorMessage: string;
    username: string;
    setUsername(username: string): void;
};

export const UsernamePanel = ({ active, busy, errorMessage, username, setUsername }: Props) => {
    const { t } = useTranslation();

    const [ showTos, setTosVisible ] = useState(false);

    return (
        <Fragment>
            <div className={ `panel ${active ? 'active' : ''}` }>
                <div>
                    <IconTextField
                        id="login-login"
                        labelKey="LOGIN.FIELD.LOGIN"
                        icon="user"
                        autoFocus={ true }
                        required={ true }
                        tabIndex={ active ? 1 : -1 }
                        disabled={ busy || !active }
                        value={ username }
                        onChange={ e => setUsername(e.currentTarget.value) }
                    />
                </div>
                <div
                    style={ { marginTop: '1em' } }
                    tabIndex={ active ? 1 : -1 }
                    dangerouslySetInnerHTML={ {
                        __html: t('LOGIN.TOS_WARNING', { 'URL': `<a href="#">${t('LOGIN.TERMS_OF_SERVICE')}</a>` } as any),
                    } }
                    onClick={ () => setTosVisible(true) }
                />
                <div style={ { marginTop: '1em', textAlign: 'right' } }>
                    <button
                        id="username-next-button"
                        className="ui primary submit button"
                        type={ active ? 'submit' : 'button' }
                        tabIndex={ active ? 1 : -1 }
                        disabled={ busy || !active || !username }
                    >
                        { t('COMMAND.NEXT') }
                    </button>
                </div>

                <ErrorMessage message={ errorMessage }/>
            </div>

            <TermsOfServiceDialog
                visible={ showTos }
                onClickClose={ () => setTosVisible(false) }
            />
        </Fragment>
    );
};
